export enum SeverityEnum {
  BLACK = 'BLACK',
  RED = 'RED',
  GRAY = 'GRAY',
  VIOLET = 'VIOLET',
  YELLOW = 'YELLOW',
  GREEN = 'GREEN'
}
